import { render, staticRenderFns } from "./ProductBoxPrice.vue?vue&type=template&id=0e2810dc"
import script from "./ProductBoxPrice.vue?vue&type=script&lang=ts"
export * from "./ProductBoxPrice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports